<template>
  <div>
    <header :class="headerClasses">
      <div class="overlay" :class="{ 'overlay--active': menuOpen }" @click="toggleMenu"></div>

      <nav class="flex flex-jc-sb flex-ai-c">
        <RouterLink class="header__logo" to="/">
          <img :src="currentLogo" class="logo" alt="logo" />
        </RouterLink>

        <span class="header__toggle hide-for-desktop" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </span>

        
        <div class="header__links hide-for-mobile">
          <RouterLink :class="linkClass" to="/">Home</RouterLink>
          <RouterLink :class="linkClass" to="/coverage">Coverage</RouterLink>
          <RouterLink :class="linkClass" to="/services">Services</RouterLink>
          <RouterLink :class="linkClass" to="/partner-center">Partner Center</RouterLink>
          <RouterLink :class="linkClass" to="/cases">Cases</RouterLink>
          <RouterLink :class="linkClass" to="/events-gallery">Events</RouterLink>
          <RouterLink :class="linkClass" to="/blogFile">Blogs</RouterLink>
        </div>

        <RouterLink class="button hide-for-mobile" to="/contact">Contact</RouterLink>
      </nav>

      
      <div class="mobile-sidebar" :class="{ 'mobile-sidebar--open': menuOpen }">
        <div class="mobile-sidebar__content">
          <a v-for="(item, index) in menuLinks" :key="index" :href="item.to" class="mobile-link" @click="toggleMenu">
            {{ item.label }}
          </a>
        </div>
      </div>
    </header>

    <Cookie />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import Cookie from '@/components/CookieConsent.vue';
import logo from '@/assets/images/bits-bluefit-small.png';
import logowhite from '@/assets/images/bits-white-ssm.png';

const route = useRoute();

const scroll = ref(false);
const menuOpen = ref(false);

const toggleMenu = () => {
  menuOpen.value = !menuOpen.value;
  document.body.classList.toggle('noscroll', menuOpen.value);
};

const onScroll = () => {
  scroll.value = window.scrollY > 1;
};

onMounted(() => {
  window.addEventListener('scroll', onScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll);
});

const pathsWithWhite = [
  '/',
  '/global-nsoc',
  '/services',
  '/services/dedicated-lines',
  '/services/business-broadband',
  '/services/wireless-connect',
  '/coverage/austria',
  '/coverage/bulgaria',
  '/coverage/mexico',
  '/coverage/turkey',
  '/coverage/indonesia',
  '/coverage/mozambique',
  '/coverage/bermuda',
  '/coverage/nigeria',
  '/coverage/qatar'
];

const showWhiteStyle = computed(() => pathsWithWhite.includes(route.path));
const currentLogo = computed(() =>
  showWhiteStyle.value && window.innerWidth > 1000 && !scroll.value ? logowhite : logo
);

const headerClasses = computed(() => {
  return {
    'header': true,
    'fixed-top': true,
    'container-fluid': true,
    'bg-white': scroll.value,
    'open': menuOpen.value,
  };
});

const linkClass = computed(() =>
  showWhiteStyle.value && !scroll.value
    ? 'header__links-link link white'
    : 'header__links-link link'
);

const menuLinks = [
  { label: 'Home', to: '/' },
  { label: 'Coverage', to: '/coverage' },
  { label: 'Services', to: '/services' },
  { label: 'Partner Center', to: '/partner-center' },
  { label: 'Cases', to: '/cases' },
  { label: 'Testimonials', to: '/testimonials' },
  { label: 'Events', to: '/events-gallery' },
  { label: 'Blogs', to: '/blogFile' },
  { label: 'Contact Us', to: '/contact' }
];
</script>

<style scoped>
.header {
  transition: background-color 300ms ease-in-out;
}

.bg-white {
  background-color: white;
}

.white {
  color: white !important;
}

.header__logo img {
  width: 150px;
}

@media (max-width: 600px) {
  .header__logo img {
    width: 100px;
  }
}

.header__toggle > span {
  display: block;
  width: 26px;
  height: 2px;
  background-color: #1a73e8;
  transition: all 300ms ease-in-out;
  transform-origin: 1.7px 1px;
  margin-bottom: 6px;
}

.header.open .header__toggle span:first-child {
  transform: rotate(45deg);
}

.header.open .header__toggle span:nth-child(2) {
  opacity: 0;
}

.header.open .header__toggle span:last-child {
  transform: rotate(-45deg);
}

.header__links-link {
    font-family: Poppins, sans-serif;
    font-size: 1.125rem;
    position: relative;
    color: rgb(31, 85, 186);
    font-weight: 400;
    transition: 0.3s ease-in-out;
    margin: 15px;
}

.header__links-link::before {
  content: '';
  position: absolute;
  height: 3px;
  left: 0;
  right: 0;
  bottom: -10px;
  background: linear-gradient(to left, #ccc, #1a73e8);
  width: 0%;
  transition: all 300ms ease-in-out;
}

.header__links-link:hover {
  color: #3b82f6;
}

.header__links-link:hover::before {
  width: 100%;
}

.button, button {
    cursor: pointer;
    color: rgb(255, 255, 255);
    font-family:Poppins, sans-serif;
    font-weight: 400;
    font-size: 20px;
    padding: 0.875rem 2.1875rem;
    background: linear-gradient(270deg, rgb(99, 168, 234), rgb(31, 85, 186));
    border-radius: 30px;
    border-width: 0px;
    border-style: initial;
    border-color: initial;
    border-image: initial;
    text-decoration: none;
    transition: 0.3s ease-in-out;
}


.mobile-sidebar {
  position: fixed;
  top: 0;
  right: -300px;
  height: 100vh;
  width: 260px;
  background-color: #fff;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  z-index: 999;
  transition: right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  padding-top: 80px;
}

.mobile-sidebar--open {
  right: 0;
}

.mobile-sidebar__content {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}

.mobile-link {
  font-size: 1rem;
  color: #1a73e8;
  padding: 1rem 0;
  font-weight: 600;
  text-decoration: none;
  border-bottom: 1px solid #f0f0f0;
}

.overlay {
  display: none;
}

.overlay--active {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 998;
}


.hide-for-mobile {
  display: block;
}
.hide-for-desktop {
  display: none;
}

@media (max-width: 768px) {
  .hide-for-mobile {
    display: none;
  }
  .hide-for-desktop {
    display: block;
  }
}
</style>
